import { render, staticRenderFns } from "./boModal.vue?vue&type=template&id=e0c655ac"
import script from "./boModal.vue?vue&type=script&lang=js"
export * from "./boModal.vue?vue&type=script&lang=js"
import style0 from "./boModal.vue?vue&type=style&index=0&id=e0c655ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports